export enum AdminLevelActive {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
